import React, { Component } from "react";
import RecordNotFound from "../../Common/RecordNotFound";
import ImageButton from "./ImageButton";
import Input from "./Input";
import ActionButton from "./ActionButton";
import _ from "lodash";
import * as actionTypes from "../../../actionTypes";
import { isMobileApp, NO_IMAGE_FOUND } from "../../../actions/Util";
import SearchBar from "./SearchBar";
import "./ListingPage.css";
import NewButton from "./NewButton";
import NewImageButton from "./NewImageButton";
import Button from "./Button";
import FooterNavButton from "./FooterNavButton";
import Icon from "./Icon";
import SideBySideLayout from "./SideBySideLayout"; // Add this import
import Pagination from "./Pagination";
import MobileMenuButton from "./MobileMenuButton";
import RowActionSheet from "./RowActionSheet";

class ListingPage extends Component {

  constructor() {
    super();

    this.state = {
      showPopupWindow: false,
      searchText: "",
      selectedRow: {},
      showMenu: false,
      showSideBySide: false, // Add this state
      selectedSideBySideRow: null ,// Add this state
          copiedLinks: {} ,
      // phone layout: rows of every page loaded so far ("View more")
      mobileRows: [],
      loadingMore: false
    };

    this.debouncedSearch = _.debounce(() => {
      let searchConfig = {};

      if (
        this.props.listPageSettings &&
        this.props.listPageSettings.hasOwnProperty("Search")
      )
        searchConfig = this.props.listPageSettings.Search;

      if (
        this.state.searchText.length >= 3 &&
        searchConfig.hasOwnProperty("onSearch")
      )
        searchConfig.onSearch(this.state.searchText);

      else if (
        this.state.searchText.length === 0 &&
        searchConfig.hasOwnProperty("onSearch")
      )
        searchConfig.onSearch("");

    }, 500);

    this.renderListSearch = this.renderListSearch.bind(this);
    this.renderRow = this.renderRow.bind(this);
    this.renderColumnText = this.renderColumnText.bind(this);
    this.onSearchChange = this.onSearchChange.bind(this);
    this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
  }

  renderCompressedHeader() {
  const { listPageSettings, searchText, onClose } = this.props;
  
  return (
    <div
      style={{
        flex: "none",
        boxShadow: "0 6px 12px rgba(0,0,0,0.15)",
        backgroundColor: "transparent",
        borderBottom: "1px solid #e5e7eb"
      }}
    >
      <div style={{ position: "relative", zIndex: 10 }}>
        <div
          style={{
               backgroundColor: "transparent",
            padding: "12px 16px"
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "16px"
            }}
          >
            {/* Left Side - Title only */}
            <div
              style={{
                minWidth: 0,
                flex: 1,
                display: "flex",
                alignItems: "center",
                gap: "12px"
              }}
            >
              {this.props.onClose && (
                <span
                  style={{
                    width: "32px",
                    height: "32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    color: "#777777",
                    cursor: "pointer",
                    transition: "0.2s ease",
                    borderRadius: "50%",
                    flexShrink: 0
                  }}
                  onClick={this.props.onClose}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.color = "#000000";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.color = "#777777";
                  }}
                >
                  <Icon type="remove" />
                </span>
              )}
              <h1
                style={{
                  fontSize: "20px",
                  fontWeight: "bold",
                  color: "#1f2937",
                  margin: 0,
                  flex: 1,
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {listPageSettings.Title}
              </h1>
            </div>

            {/* Right Side - Only essential action buttons */}
    <div
    className="margin-bottom-zero"
  style={{
    display: "flex",
    gap: "12px",
    alignItems: "center",
    flexShrink: 0,
  }}
>
  {this.props.listPageSettings.HeaderButtons.map(
    (button, index) => (
      <React.Fragment key={index}>
        {button.ButtonType && button.ButtonType.toLowerCase() === "button" && (
          // Check if button should show in compact mode
          (button.hasOwnProperty('showInCompact') ? button.showInCompact : true) && (
          <div className="margin-bottom-zero">
            <NewButton
              type={button.Type}
              text={button.Text}
              icon={button.Icon}
              onClick={() => this.onHeaderButtonClicked(button)}
            />
            </div>
          )
        )}
        {button.ButtonType && button.ButtonType.toLowerCase() === "imagebutton" && (
          // Check if button should show in compact mode
          (button.hasOwnProperty('showInCompact') ? button.showInCompact : true) && (
            <NewImageButton
              type={button.Type}
              label={button.Text}
              onClick={() => this.onHeaderButtonClicked(button)}
            />
          )
        )}
      </React.Fragment>
    )
  )}
</div>
          </div>

          {/* Search bar for compressed view - only if search is enabled */}
          {this.props.listPageSettings.Search && 
           this.props.listPageSettings.Search.hasOwnProperty("showSearch") && 
           this.props.listPageSettings.Search.showSearch && (
            <div style={{ marginTop: "12px" }}>
              <SearchBar
                value={searchText}
                onChange={this.onSearchChange}
                placeholder={(this.props.listPageSettings.Search.hasOwnProperty("placeholder") && this.props.listPageSettings.Search.placeholder) || "Search..."}
                hideFilter={this.props.listPageSettings.Search.hasOwnProperty("hideFilter") ? this.props.listPageSettings.Search.hideFilter : false}
                hideRefresh={this.props.listPageSettings.Search.hasOwnProperty("hideRefresh") ? this.props.listPageSettings.Search.hideRefresh : false}
                handleRefreshClick={this.props.listPageSettings.Search.hasOwnProperty("onRefresh") ? this.props.listPageSettings.Search.onRefresh : null}
                handleFilterClick={this.props.listPageSettings.Search.hasOwnProperty("onFilterClick") ? this.props.listPageSettings.Search.onFilterClick : null}
                isFilterActive={this.props.listPageSettings.Search.hasOwnProperty("isFilterActive") ? this.props.listPageSettings.Search.isFilterActive : false}
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

  // Add this method to render shimmer rows
  renderShimmerRow = (columns, hasActions, isMobile = false) => {
    const shimmerAnimation = {
      animation: 'shimmer-pulse 1.5s ease-in-out infinite'
    };

    const shimmerLineStyle = {
      height: '16px',
      background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
      backgroundSize: '200% 100%',
      borderRadius: '4px',
      animation: 'shimmer-loading 1.5s ease-in-out infinite'
    };

    const shimmerCheckboxStyle = {
      width: '16px',
      height: '16px',
      background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
      backgroundSize: '200% 100%',
      borderRadius: '3px',
      animation: 'shimmer-loading 1.5s ease-in-out infinite'
    };

    const shimmerButtonStyle = {
      width: '60px',
      height: '28px',
      background: 'linear-gradient(90deg, #e0e0e0 25%, #f0f0f0 50%, #e0e0e0 75%)',
      backgroundSize: '200% 100%',
      borderRadius: '4px',
      margin: '0 auto',
      animation: 'shimmer-loading 1.5s ease-in-out infinite'
    };

    
    if (isMobile) {
      return (
        <div style={{ ...shimmerAnimation, padding: '12px 0' }}>
          {columns.map((col, idx) => (
            <div key={idx} className="row-text" style={{ marginBottom: '8px' }}>
              {col.Type === "checkbox" ? (
                <div style={shimmerCheckboxStyle}></div>
              ) : (
                <div style={shimmerLineStyle}></div>
              )}
            </div>
          ))}
        </div>
      );
    }

    return (
      <tr style={shimmerAnimation}>
        {columns.map((col, idx) => (
          <td key={idx} style={{ padding: "10px 12px" }}>
            {col.Type === "checkbox" ? (
              <div style={shimmerCheckboxStyle}></div>
            ) : (
              <div style={shimmerLineStyle}></div>
            )}
          </td>
        ))}
        {hasActions && (
          <td style={{ padding: "8px", textAlign: "center" }}>
            <div style={shimmerButtonStyle}></div>
          </td>
        )}
      </tr>
    );
  };

  componentDidMount() {
    // Add CSS keyframes dynamically
    const styleSheet = document.createElement("style");
    styleSheet.textContent = `
    @keyframes shimmer-pulse {
      0% { opacity: 0.3; }
      50% { opacity: 0.8; }
      100% { opacity: 0.3; }
    }
    @keyframes shimmer-loading {
      0% { background-position: 200% 0; }
      100% { background-position: -200% 0; }
    }
  `;
    document.head.appendChild(styleSheet);
    if (isMobileApp()) {
      // Saved page filters can bring a list back on page N; "View more" needs
      // to build up from the first page.
      if ((this.props.recordFrom || 0) > 0 && this.props.onPageChange) {
        this.props.onPageChange(1, this.props.itemsCountPerPage || 25);
      } else {
        this.syncMobileRows(null);
      }
    }
  }

  componentDidUpdate(prevProps) {
    // If searchText prop changes, update the local state
    if (prevProps.searchText !== this.props.searchText) {
      this.setState({ searchText: this.props.searchText || "" });
    }
    if (isMobileApp()) {
      this.syncMobileRows(prevProps);
    }
  }

  // Phone lists use "View more" instead of page numbers: keep the rows of the
  // pages already loaded and append each new page as it arrives. Any load that
  // starts from the first record (search, filter, refresh) starts over.
  syncMobileRows(prevProps) {
    if (prevProps && prevProps.list === this.props.list && prevProps.loading === this.props.loading) {
      return;
    }
    if (this.props.loading) {
      return;
    }
    const list = this.props.list || [];
    const from = this.props.recordFrom || 0;
    const rows = this.state.mobileRows;
    // Put the page at its offset, so reloading a later page (after an edit)
    // keeps the rows above it.
    const mobileRows = from > 0 && rows.length >= from ? rows.slice(0, from).concat(list) : list;
    this.setState({ mobileRows, loadingMore: false });
  }

  onViewMore = () => {
    const pageSize = this.props.itemsCountPerPage || 25;
    const nextPage = Math.floor((this.props.recordFrom || 0) / pageSize) + 2;
    this.setState({ loadingMore: true }, () => {
      this.props.onPageChange(nextPage, pageSize);
    });
  };

  // Columns shown on phones. Lists that flag none with ShowInMobile would
  // otherwise render empty rows, so fall back to the desktop columns.
  getMobileColumns() {
    const columns = this.props.listPageSettings.Columns || [];
    const mobile = columns.filter((f) => f.ShowInMobile);
    if (mobile.length > 0) {
      return { columns: mobile, fallback: false };
    }
    return {
      columns: columns.filter((f) => f.Type !== "checkbox" && f.Type !== "button"),
      fallback: true
    };
  }

  renderMobileRows() {
    const { columns, fallback } = this.getMobileColumns();
    return this.state.mobileRows.map((l, index) => (
      <div
        key={"row" + index}
        className={"list-row seperator" + (fallback ? " list-row-fallback" : "")}
        style={this.props.enableSideBySide ? { cursor: "pointer" } : (this.props.onRowClick ? { cursor: "pointer" } : {})}
        onClick={() => {
          if (this.props.enableSideBySide) {
            this.onRowClickForSideBySide(l);
          } else if (this.props.onRowClick) {
            this.onRowClick(l);
          } else if (this.props.listPageSettings.RowButtons.length === 1) {
            this.onRowButtonClicked(
              this.props.listPageSettings.RowButtons[0],
              l
            );
          } else if (this.props.listPageSettings.RowButtons.length > 1) {
            this.setState({
              showPopupWindow: true,
              selectedRow: l
            });
          }
        }}
      >
        {columns.map((col, colIndex) => {
          const content = this.renderRow(l, col, index, fallback);
          if (content === null || content === undefined) return null;
          return (
            <div key={"col" + colIndex} className="row-text">
              {fallback && colIndex > 0 && col.Name && (
                <span className="row-label">{col.Name}</span>
              )}
              {content}
            </div>
          );
        })}
      </div>
    ));
  }

  // Phone header filter button (the search field drops its own filter icon)
  renderMobileFilterButton() {
    const search = this.props.listPageSettings.Search || {};
    if (!search.onFilterClick || search.hideFilter) return null;
    return (
      <span
        className={"mobile-header-filter" + (search.isFilterActive ? " is-active" : "")}
        aria-label={search.isFilterActive ? "Filter (active)" : "Filter"}
      >
        <NewImageButton type="filter" icon="filter" onClick={search.onFilterClick} />
      </span>
    );
  }

  renderMobileListFooter() {
    const total = this.props.totalItemsCount || 0;
    const shown = this.state.mobileRows.length;
    if (shown === 0) return null;
    return (
      <div className="listing-page-view-more">
        <div className="listing-page-view-more-status">
          Showing {shown} of {total}
        </div>
        {shown < total && this.props.onPageChange && (
          <button
            type="button"
            className="listing-page-view-more-btn"
            disabled={this.state.loadingMore}
            onClick={(e) => {
              e.stopPropagation();
              this.onViewMore();
            }}
          >
            {this.state.loadingMore ? "Loading..." : "View more"}
          </button>
        )}
      </div>
    );
  }

  handleCheckboxChange(index, newValue) {
    if (this.props.checkboxSelected) {
      this.props.checkboxSelected(index, newValue);
    }
  }

  onRowButtonClicked = (button, row) => {
    if (this.props.onRowButtonClicked)
      this.props.onRowButtonClicked(button, row);
  };

  onHeaderButtonClicked = (button) => {
    if (this.props.onHeaderButtonClicked)
      this.props.onHeaderButtonClicked(button);
  };

 
  // Add method for side-by-side row click
  onRowClickForSideBySide = (row) => {
    console.log("onrowclick 175");
    if (this.props.enableSideBySide) {
      this.setState({
        showSideBySide: true,
        selectedSideBySideRow: row
      });
    } else if (this.props.onRowClick) {
      this.props.onRowClick(row);
    }
  };

  // Add method to close side-by-side
  onCloseSideBySide = () => {
    this.setState({
      showSideBySide: false,
      selectedSideBySideRow: null
    });
  };

  onSearchChange(value) {
    this.setState(
      {
        searchText: value
      },
      () => {
        this.debouncedSearch();
      }
    );
  }

  renderListSearch(isMobile = false) {
    let searchConfig = {};

    if (
      this.props.listPageSettings &&
      this.props.listPageSettings.hasOwnProperty("Search")
    )
      searchConfig = this.props.listPageSettings.Search;

    return (
      <div
        style={{
          height: "34px",
          width: isMobile ? "100%" : "350px",
          marginRight: isMobile ? "0px" : "10px"
        }}
      >
        <SearchBar
          value={this.state.searchText}
          onChange={this.onSearchChange}
          hideFilter={
            // phones show the filter in the header instead
            isMobile ||
            (searchConfig.hasOwnProperty("hideFilter")
              ? searchConfig.hideFilter
              : false)
          }
          hideRefresh={searchConfig.hasOwnProperty("hideRefresh")
            ? searchConfig.hideRefresh
            : false}
          handleRefreshClick={
            searchConfig.hasOwnProperty("onRefresh")
              ? searchConfig.onRefresh
              : null
          }
          handleFilterClick={
            searchConfig.hasOwnProperty("onFilterClick")
              ? searchConfig.onFilterClick
              : null
          }
          isFilterActive={
            searchConfig.hasOwnProperty("isFilterActive")
              ? searchConfig.isFilterActive
              : false
          }
          placeholder={
            searchConfig.hasOwnProperty("placeholder")
              ? searchConfig.placeholder
              : ""
          }
        />
      </div>
    );
  }

renderRowButtons(index, l) {
  return (
    <>
      {
        this.props.listPageSettings.RowButtons.length > 0 &&
        <td key={"rowBtns" + index}>
          <div className="listing-page-row-btns" style={{ 
            display: "flex", 
            gap: "8px",  // This adds spacing between buttons
            alignItems: "center",
            justifyContent: "center"
          }}>
            {
              this.props.listPageSettings.RowButtons
                .filter(button => {
                  if (
                    l.hasOwnProperty("IsDeleted") &&
                    l.IsDeleted === true &&
                    button.hasOwnProperty("Type") &&
                    (button.Type.toLowerCase() === "edit" ||
                      button.Type.toLowerCase() === "delete")
                  ) {
                    return false;
                  }
                  if (button.condition)
                    return button.condition(l);
                  return true;
                })
                .map((button, btnIndex) => {
                  let modifiedButton = { ...button };
                  let buttonText = button.Text;
                  if (typeof button.Text === 'function') {
                    buttonText = button.Text(l);
                  }
                  
                  return (
                    <React.Fragment key={btnIndex}>
                      {
                        button.ButtonType.toLowerCase() === "button" &&
                        <Button
                          type={button.Type}
                          text={buttonText}
                          icon={button.Icon}
                          onClick={(e) =>{
                            e.stopPropagation();
                            this.onRowButtonClicked(modifiedButton, l)
                          }}
                        />
                      }
                      {
                        button.ButtonType.toLowerCase() === "imagebutton" &&
                        <ImageButton
                          type={button.Type}
                          label={button.Text}
                          icon={button.Icon}
                          onClick={(e) =>{
                            e.stopPropagation();
                            this.onRowButtonClicked(modifiedButton, l)
                          }}
                        />
                      }
                      {
                        button.ButtonType.toLowerCase() === "custom" &&
                        button.renderButton && (
                          <div onClick={(e) => e.stopPropagation()}>
                            {button.renderButton(l, (action, row) => {
                              this.onRowButtonClicked({ Action: action, ...button }, row);
                            })}
                          </div>
                        )
                      }
                    </React.Fragment>
                  );
                })
            }
          </div>
        </td>
      }
    </>
  );
}

  renderRow(row, col, index, forceOnMobile = false) {
    if (col.condition && !col.condition(row)) {
      return null;
    }
    if (
      isMobileApp() &&
      !col.ShowInMobile &&
      !forceOnMobile
    )
      return;

    if (
      !isMobileApp() &&
      col.ShowInMobile
    )
      return;

        if (col.Type === "custom") {
    // If there's a renderCell function, call it with the row and other context
    if (col.renderCell) {
      return col.renderCell({ row, index, col });
    }
    return null;
  }
    if (col.Type === "checkbox") {
      return (
        <div onClick={(e) => e.stopPropagation()}>
          <Input
            type="checkbox"
            value={row.Selected || false}
            onChange={(newValue) => this.handleCheckboxChange(index, newValue)}
            noMargin={true}
          />
        </div>
      );
    }
    else if (col.Type === "address") {
      return (
        <React.Fragment>
          {row.Addresses &&
            row.Addresses.map((address) => (
              <div>
                <div>
                  <b>{address.AddressType}</b>
                </div>
                <div>{address.Address1}</div>
                <div>{address.Address2}</div>
                <div>{address.City}</div>
                <div>{address.State}</div>
                <div>{address.PostalCode}</div>
                <div>{address.Country}</div>
              </div>
            ))}
        </React.Fragment>
      );
    }
    else if (col.Type === "payments") {
      return (
        <React.Fragment>
          {(row.Payments || []).map((payment) => (
            <div>
              {payment.PaymentMode +
                " " +
                ":" +
                " " +
                (payment.PaymentMode === "Cash"
                  ? payment.Amount - row.BillChangeDue
                  : payment.Amount)}
            </div>
          ))}
        </React.Fragment>
      );
    }
    if (col.Type === "multiple") {
      return (
        <>
          {
            col.Columns
              .filter(c => {
                if (c.condition)
                  return c.condition(row);
                return true;
              }).map((c, i) => {
                const hasLabel =
                  Object.prototype.hasOwnProperty.call(c, "Label") &&
                  c.Label;
                return (
                  <div
                    key={i}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "4px",
                      marginBottom: "2px"
                    }}
                  >
                    {hasLabel && (
                      <span style={{ fontWeight: 500 }}>
                        {c.Label} :
                      </span>
                    )}
                    {
                      this.renderColumnText(
                        row,
                        c.Column,
                        c.Type,
                        c,
                        index
                      )
                    }
                  </div>
                );
              })
          }
        </>
      );
    }
    else if (col.Type === "list") {
      if (row[col.Column]) {
        if (col.hasOwnProperty("Columns")) {
          return (
            <React.Fragment>
              {row[col.Column].map((a) => (
                <React.Fragment>
                  {col.Columns.map((s) => (
                    <div className="badge">{a[s.Column]}</div>
                  ))}
                </React.Fragment>
              ))}
            </React.Fragment>
          );
        }
      }
    }
    if (col.Type === "payments") {
      return (
        <>
          {
            (row.Payments || [])
              .map((p) => (
                <div>
                  {
                    p.PaymentMode +
                    " : " +
                    (
                      p.PaymentMode === "Cash"
                        ?
                        p.Amount -
                        row.BillChangeDue
                        :
                        p.Amount
                    )
                  }
                </div>
              ))
          }
        </>
      );
    }

    if (col.Columns && col.Columns.length > 0) {
      return (
        <>
          {
            col.Columns.map((c, i) => {
              const hasLabel =
                Object.prototype.hasOwnProperty.call(c, "Label") &&
                c.Label;
              return (
                <div
                  key={i}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "4px",
                    marginBottom: "2px"
                  }}
                >
                  {hasLabel && (
                    <span style={{ fontWeight: 500 }}>
                      {c.Label} :
                    </span>
                  )}
                  {
                    this.renderColumnText(
                      row,
                      c.Column,
                      c.Type,
                      c,
                      index
                    )
                  }
                </div>
              );
            })
          }
        </>
      );
    }

    return (
      <div>
        {
          this.renderColumnText(
            row,
            col.Name,
            col.Type,
            col,
            index
          )
        }
      </div>
    );
  }

  renderColumnText(row, fieldName, fieldType, col, index) {
    let value = null;
if (fieldType === "link") {
  const link = this.getNestedValue(row, fieldName);
  if (!link) return null;
  
  const shouldShowCopy = true;
  const displayText = shouldShowCopy 
      ? link.substring(0, 50) + "..."
      : link;

  // Create a unique key for this link
  const linkKey = `${index}-${fieldName}`;
  const isCopied = this.state.copiedLinks[linkKey] || false;

  return (
      <div style={{ 
          display: 'inline-flex', 
          alignItems: 'center', 
          gap: '4px',
          maxWidth: '100%',
          width: '100%'
      }}>
          <span 
              style={{ 
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  flex: '0 1 auto',
                  minWidth: 0,
                  color: '#0066cc',
                  display: 'inline-block',
                  maxWidth: 'calc(100% - 40px)'
              }}
              title={link}
          >
              {displayText}
          </span>
          {shouldShowCopy && (
              <button
                  onClick={(e) => {
                      e.stopPropagation();
                      navigator.clipboard.writeText(link);
                      // Update state for this specific link
                      this.setState({
                          copiedLinks: {
                              ...this.state.copiedLinks,
                              [linkKey]: true
                          }
                      });
                      // Reset after 3 seconds
                      setTimeout(() => {
                          this.setState(prevState => ({
                              copiedLinks: {
                                  ...prevState.copiedLinks,
                                  [linkKey]: false
                              }
                          }));
                      }, 3000);
                  }}
                  style={{
                      padding: '1px 6px',
                      fontSize: '10px',
                      backgroundColor: isCopied ? '#059669' : '#065fd4',
                      color: 'white',
                      border: 'none',
                      borderRadius: '2px',
                      cursor: 'pointer',
                      flexShrink: 0,
                      lineHeight: '1.4',
                      display: 'inline-block',
                      whiteSpace: 'nowrap',
                      transition: 'background-color 0.2s ease'
                  }}
                  onMouseEnter={(e) => {
                      if (!isCopied) {
                          e.currentTarget.style.backgroundColor = '#0353a4';
                      }
                  }}
                  onMouseLeave={(e) => {
                      if (!isCopied) {
                          e.currentTarget.style.backgroundColor = '#065fd4';
                      }
                  }}
              >
                  {isCopied ? 'Copied!' : 'Copy'}
              </button>
          )}
      </div>
  );
}

    if (col && col.Type === "list") {
        if (row[col.Column] && Array.isArray(row[col.Column])) {
            if (col.hasOwnProperty("Columns")) {
                return (
                    <React.Fragment>
                        {row[col.Column].map((a, itemIndex) => (
                            <React.Fragment key={itemIndex}>
                                {col.Columns.map((s, subIndex) => (
                                    <div key={subIndex} className="badge">{a[s.Column]}</div>
                                ))}
                            </React.Fragment>
                        ))}
                    </React.Fragment>
                );
            }
        }
        return null;
    }

    if (col && col.Type === "concatenate") {
        value = (col.Columns || [])
            .map(c => this.getNestedValue(row, c.Column))
            .filter(v => v)
            .join(" ");
    }
    else {
        value = this.getNestedValue(row, fieldName);
    }

    let displayValue = value;

    if (fieldType === "checkbox") {
        return (
            <div onClick={(e) => e.stopPropagation()}>
                <Input
                    type="checkbox"
                    value={row.Selected || false}
                    onChange={(newValue) => this.handleCheckboxChange(index, newValue)}
                    noMargin={true}
                />
            </div>
        );
    }

    if (col && col.Type === "custom") {
        if (col.renderCell) {
            return col.renderCell({ row, index, col });
        }
        return null;
    }

    if (fieldType === "image") {
        return (
            <img
                src={value || NO_IMAGE_FOUND}
                alt=""
                style={{
                    width: "100px",
                    height: "100px",
                    objectFit: "cover",
                    borderRadius: "4px"
                }}
            />
        );
    }

    if (fieldType === "color") {
        if (!value)
            return null;
        return (
            <>
                <div
                    style={{
                        width: "20px",
                        height: "20px",
                        backgroundColor: value,
                        border: "1px solid #ccc",
                        borderRadius: "4px",
                        display: "inline-block",
                        marginRight: "6px"
                    }}
                />
                <span>
                    {value}
                </span>
            </>
        );
    }

    if (fieldType === "yesno") {
        return (
            <span>
                {value ? "Yes" : "No"}
            </span>
        );
    }

    if (fieldType === "badge" && value) {
        let css = "badge";
        if (col && col.hasOwnProperty("CSS")) {
            css = css + " " + col.CSS;
        }
        return (
            <div className={css}>
                {value}
            </div>
        );
    }

    if (fieldType === "number") {
        return (
            <div>
                {(value !== null && value !== undefined && value !== "") ? value : 0}
            </div>
        );
    }

    if (fieldType === "date" && value) {
        return (
            <div>
                {new Date(value).toLocaleDateString()}
            </div>
        );
    }

    return (
        <div>
            {displayValue}
        </div>
    );
}
  getNestedValue(row, path) {
    let value = row;
    let normalizedPath = path.replace(/\[(\d+)\]/g, ".$1");
    let parts = normalizedPath.split(".");
    for (let i = 0; i < parts.length; i++) {
      if (value && Object.prototype.hasOwnProperty.call(value, parts[i])) {
        value = value[parts[i]];
      } else {
        return null;
      }
    }
    return value;
  }

  getPageNumbers() {
    const totalItems = this.props.totalItemsCount || 0;
    const pageSize = this.props.itemsCountPerPage || 10;
    const currentPage = Math.floor((this.props.recordFrom || 0) / pageSize) + 1;
    const totalPages = Math.ceil(totalItems / pageSize);
    let pages = [];
    let start = Math.max(1, currentPage - 2);
    let end = Math.min(totalPages, start + 4);
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return {
      pages,
      currentPage,
      totalPages
    };
  }

  showPaginationStatus() {
    const recordFrom = this.props.recordFrom || 0;
    const itemsCountPerPage = this.props.itemsCountPerPage || 0;
    const totalItemsCount = this.props.totalItemsCount || 0;
    let paginationStatus;

    if (totalItemsCount === 0) {
      paginationStatus = "No record(s) found";
    }
    else if (recordFrom + 1 === totalItemsCount) {
      paginationStatus = "Showing " + totalItemsCount + " of " + totalItemsCount;
    }
    else if (recordFrom + itemsCountPerPage > totalItemsCount) {
      paginationStatus = "Showing " + (recordFrom + 1) + " to " + totalItemsCount + " of " + totalItemsCount;
    }
    else {
      paginationStatus = "Showing " + (recordFrom + 1) + " to " + (recordFrom + itemsCountPerPage) + " of " + totalItemsCount;
    }

    return (
      <div
        className={isMobileApp() ? "listing-page-mobile-pagination" : "listing-page-pagination"}
        style={{ fontSize: "12px" }}
      >
        {paginationStatus}
      </div>
    );
  }

  renderMobile() {
    let showSearch = false;

    if (
      this.props.listPageSettings &&
      this.props.listPageSettings.hasOwnProperty("Search")
    ) {
      if (this.props.listPageSettings.Search.hasOwnProperty("showSearch")) {
        showSearch = this.props.listPageSettings.Search.showSearch;
      }
    }

    const renderContent = () => (
      <React.Fragment>
        <div className="list-page-mobile-background"></div>

        <div className="listing-page-mobile-header">
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              minHeight: "48px"
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                flex: 1,
                minWidth: 0
              }}
            >
              <MobileMenuButton {...this.props} />
              <div
                className="listing-page-mobile-header-title"
                style={{
                  display: "flex",
                  alignItems: "center",
                  height: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis"
                }}
              >
                {this.props.listPageSettings.Title}
              </div>
            </div>

            <div
              style={{
                display: "flex",
                gap: "8px",
                alignItems: "center",
                marginLeft: "10px"
              }}
            >
              {showSearch && this.renderMobileFilterButton()}
              {this.props.listPageSettings.HeaderButtons
                .filter(f => f.Icon !== "add")
                .map((button, index) => (
                  <React.Fragment key={index}>
                    {button.ButtonType.toLowerCase() === "button" && (
                      <Button
                        type={button.Type}
                        text={button.Text}
                        icon={button.Icon}
                        onClick={() => this.onHeaderButtonClicked(button)}
                      />
                    )}
                    {button.ButtonType.toLowerCase() === "imagebutton" && (
                      <NewImageButton
                        type={button.Type}
                        label={button.Text}
                        icon={button.Icon}
                        onClick={() => this.onHeaderButtonClicked(button)}
                      />
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>
        </div>

        {showSearch &&
          <div className="mobile-search-container">
            {this.renderListSearch(true)}
          </div>}

        <div className="listing-page-content custom-scrollable" style={{
          position: "fixed",
          top: showSearch ? "116px" : "60px",
          bottom: 0,
          left: 0,
          right: 0,
          overflowY: "auto",
          backgroundColor: "white"
        }}>
          {this.renderMobileRows()}

          {this.props.loading && this.state.mobileRows.length === 0 && (
            <div className="listing-page-mobile-shimmer">
              {[0, 1, 2, 3, 4, 5].map((i) => (
                <div key={i} className="list-row">
                  <div className="shimmer-line" style={{ width: "55%" }} />
                  <div className="shimmer-line" style={{ width: "35%" }} />
                  <div className="shimmer-line" style={{ width: "45%" }} />
                </div>
              ))}
            </div>
          )}

          {this.renderMobileListFooter()}

          {
            this.state.mobileRows.length === 0 && !this.props.loading && (
              <div style={{ paddingTop: "80px" }}>
                <RecordNotFound />
              </div>
            )
          }
        </div>

        {
          this.props.listPageSettings.HeaderButtons
            .filter(f => f.Icon === "add")
            .map((button, index) => (
              <ActionButton
                key={index}
                type="add"
                icon="add"
                label={button.Text}
                bottom="24px"
                onClick={() => this.onHeaderButtonClicked(button)}
              />
            ))
        }


      </React.Fragment>
    );

    // If side-by-side is enabled and showing
    if (this.props.enableSideBySide && this.state.showSideBySide) {
        if (this.props.renderSideBySide) {
    return (
      <SideBySideLayout
        left={renderContent()}
        right={this.props.renderSideBySide(
          this.state.selectedSideBySideRow,
          this.onCloseSideBySide
        )}
      />
    );
  }
     
    }

    return renderContent();
  }

  onRowClick = (row) => {
    if (this.props.onRowClick) {
      this.props.onRowClick(row);
    }
  };

renderDesktop() {
  let showSearch = false;
  const isCompress = this.state.showSideBySide;

  const getColumnsToRender = () => {
    if (this.state.showSideBySide && this.props.compactTableColumns) {
      return this.props.compactTableColumns;
    }
    return this.props.listPageSettings.Columns;
  };

  if (
    this.props.listPageSettings &&
    this.props.listPageSettings.hasOwnProperty("Search")
  ) {
    if (this.props.listPageSettings.Search.hasOwnProperty("showSearch"))
      showSearch = this.props.listPageSettings.Search.showSearch;
  }

  const renderContent = () => (
    <div style={{ 
      padding:isCompress ?  "0px" : "10px",
      display: "flex", 
      flexDirection: "column", 
      height: "100vh",
      overflow: "hidden"
    }}>
      {/* Conditional Header Rendering */}
      {isCompress ? (
        // Use compressed header when isCompress is true
        this.renderCompressedHeader()
      ) : (
        // Use regular header when not compressed
        <div style={{  flexShrink: 0 }} className="">
          <div className="listing-page-header">
            <div className="left left-40">
              <div className="listing-page-header-title">
                {this.props.listPageSettings.Title}
              </div>
            </div>
            <div className="right right-60">
              {showSearch && this.renderListSearch()}
              {this.props.listPageSettings.HeaderButtons.map(
                (button, index) => (
                  <React.Fragment key={index}>
                    {button.ButtonType.toLowerCase() === "button" &&
                      <NewButton
                        type={button.Type}
                        text={button.Text}
                        icon={button.Icon}
                        onClick={() => this.onHeaderButtonClicked(button)}
                      />
                    }
                    {button.ButtonType.toLowerCase() === "imagebutton" &&
                      <NewImageButton
                        type={button.Type}
                        label={button.Text}
                        onClick={() => this.onHeaderButtonClicked(button)}
                      />
                    }
                  </React.Fragment>
                )
              )}
              {this.props.onClose && <span
                style={{
                  height: "34px",
                  width: "34px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  color: "#777777",
                  cursor: "pointer",
                  transition: "0.2s ease",
                  borderRadius: "50%",
                }}
                onClick={this.props.onClose}
                onMouseEnter={(e) => {
                  e.currentTarget.style.color = "#000000";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.color = "#777777";
                }}
              >
                <Icon type="remove" />
              </span>}
            </div>
          </div>
        </div>
      )}

      {/* Dynamic height calculation for table content - make it scrollable */}
      <div
        className="listing-page-content custom-scrollable"
        style={{
          flex: 1,
          overflowY: "auto",
          backgroundColor: "white",
          minHeight: 0 // Important for flex children to scroll properly
        }}
      >
        {/* Your table code remains exactly the same */}
        <table
          style={{
            width: "100%",
            borderCollapse: "separate",
            borderSpacing: "0",
            fontSize: "13px"
          }}
        >
          {/* Table header and body remain unchanged */}
          {(!this.props.hideTableHeaderInCompact || !this.state.showSideBySide) && (
            <thead
              className="bg-indigo-soft-gradient"
              style={{
                position: "sticky",
                top: 0,
                zIndex: 10,
                color: "#374151",
              }}
            >
              <tr>
                {getColumnsToRender()
                  .filter(f => !f.ShowInMobile)
                  .map((c, index) => (
                    <th
                      key={index}
                      style={{
                        padding: "12px 14px",
                        textAlign: c.Type === "number" || c.Type === "currency" ? "right" : "left",
                        fontWeight: 600,
                        fontSize: "10px",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        borderBottom: "1px solid #e5e7eb",
                        position: "sticky",
                        top: 0,
                        zIndex: 11
                      }}
                    >
                      {c.Type === "checkbox" && (
                        <div onClick={(e) => e.stopPropagation()}>
                          <Input
                            type="checkbox"
                            noMargin={true}
                            value={this.props.selectAll || false}
                            onChange={(newValue) => this.handleCheckboxChange(-1, newValue)}
                          />
                        </div>
                      )}
                      {c.Name}
                    </th>
                  ))}
                {this.props.listPageSettings.RowButtons.length > 0 && (
                  <th
                    key="rowBtns"
                    style={{
                      width: this.state.rowButtonWidth || "120px",
                      textAlign: "center",
                      borderBottom: "1px solid #e5e7eb",
                      padding: "12px",
                      fontWeight: 600,
                      fontSize: "10px",
                      textTransform: "uppercase",
                      letterSpacing: "0.5px",
                      position: "sticky",
                      top: 0,
                      zIndex: 11
                    }}
                  >
                    Actions
                  </th>
                )}
              </tr>
            </thead>
          )}
          
          <tbody>
            {this.props.loading ? (
              Array(this.props.itemsCountPerPage || 25).fill().map((_, idx) => (
                this.renderShimmerRow(
                  getColumnsToRender().filter(f => !f.ShowInMobile),
                  this.props.listPageSettings.RowButtons.length > 0,
                  false
                )
              ))
            ) : (
              this.props.list.map((l, index) => (
                <tr
                  key={"tdtr" + index}
                  style={{
                    transition: "background 0.18s ease",
                    cursor: this.props.enableSideBySide ? "pointer" : (this.props.onRowClick ? "pointer" : "default")
                  }}
                  onClick={() => {
                    if (this.props.enableSideBySide) {
                      this.onRowClickForSideBySide(l);
                    } else if (this.props.onRowClick) {
                      this.onRowClick(l);
                    }
                  }}
                  onMouseEnter={e => (e.currentTarget.style.background = "#f8faff")}
                  onMouseLeave={e => (e.currentTarget.style.background = "transparent")}
                >
                  {getColumnsToRender()
                    .filter(f => !f.ShowInMobile)
                    .map((col, colIndex) => (
                      <td
                        key={"td" + colIndex}
                        style={{
                          padding: "10px 12px",
                          borderBottom: "1px solid #f1f5f9",
                          textAlign: col.Type === "number" || col.Type === "currency" ? "right" : "left",
                          verticalAlign: "top",
                          whiteSpace: col.Type === "date" || col.Type === "number" || col.Type === "currency" ? "nowrap" : "normal"
                        }}
                      >
                        {this.renderRow(l, col, index)}
                      </td>
                    ))}
                  {(this.props.listPageSettings.RowButtons.length > 0 && !this.state.showSideBySide) && (
                    <td
                      style={{
                        textAlign: "center",
                        padding: "8px",
                        borderBottom: "1px solid #f1f5f9",
                        verticalAlign: "top",
                        width: this.state.rowButtonWidth || "120px"
                      }}
                    >
                      {this.renderRowButtons(index, l)}
                    </td>
                  )}
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination - now always visible at bottom */}
      <div style={{ flexShrink: 0 }}>
        <Pagination
          isCompress={this.state.showSideBySide}
          count={this.props.totalItemsCount || 0}
          page={Math.floor((this.props.recordFrom || 0) / (this.props.itemsCountPerPage || 25)) + 1}
          rowsPerPage={this.props.itemsCountPerPage || 25}
          onPageChange={(newPage) => {
            this.props.onPageChange(newPage, this.props.itemsCountPerPage);
          }}
          onRowsPerPageChange={(newRowsPerPage) => {
            this.props.onRecordsPerPageCountChange(newRowsPerPage);
          }}
        />
      </div>
    </div>
  );

  // Side-by-side logic remains the same
  if (this.props.enableSideBySide && this.state.showSideBySide) {
       if (this.props.renderSideBySide) {
    return (
      <SideBySideLayout
        left={renderContent()}
        right={this.props.renderSideBySide(
          this.state.selectedSideBySideRow,
          this.onCloseSideBySide
        )}
      />
    );
  }
  
  }

  return renderContent();
}

  closeRowOptions = () => {
    this.setState({ showPopupWindow: false, selectedRow: {} });
  };

  render() {
    return (
      <>
        {isMobileApp() && this.renderMobile()}
        {this.state.showPopupWindow && (
          <RowActionSheet
            row={this.state.selectedRow}
            buttons={this.props.listPageSettings.RowButtons}
            onAction={this.onRowButtonClicked}
            onClose={this.closeRowOptions}
          />
        )}
        {!isMobileApp() && (
          <div className="header-margin">
            {this.renderDesktop()}
          </div>
        )}
      </>
    );
  }
}

export default ListingPage;